import { FC } from 'react';
import Script from 'next/script';

const ReadBanner: FC = () => {
  return (
    <>
      <Script strategy="lazyOnload">
        {`
          window.yaContextCb.push(()=>{
          Ya.Context.AdvManager.render({
          renderTo: 'yandex_rtb_R-A-1489660-7',
          blockId: 'R-A-1489660-7'})})
        `}
      </Script>
      <Script strategy="lazyOnload">
        {`
          window.yaContextCb.push(()=>{
          Ya.Context.AdvManager.render({
          renderTo: 'yandex_rtb_R-A-1489660-8',
          blockId: 'R-A-1489660-8'})})
        `}
      </Script>
    </>
  );
};

export default ReadBanner;
